import { getStore } from "../store/Store";

/**
 * Returns the persisted Favorites pane height in px, or null when the user has not resized it yet
 * (in which case the CSS default max-height applies).
 */
export function getFavoritesPaneHeight(): number | null {
    return getStore().favoritesPaneHeight;
}
